import { useAuthStore } from '../stores/authStore'

export function getCurrentBearerToken() {
  const token = useAuthStore.getState().token

  return token
}
